// extracted by mini-css-extract-plugin
export var wrapper = "PinkModule-module--wrapper--9nW2a";
export var container = "PinkModule-module--container--9XSTl";
export var submodule = "PinkModule-module--submodule---J0bQ";
export var icon = "PinkModule-module--icon--jxgAW";
export var text = "PinkModule-module--text--CAgUj";